import React from 'react';
import { Loader, Portal } from '@mantine/core';

const Spinner = () => (
  <Portal>
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 10000,
        background: 'rgba(255, 255, 255, 0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Loader size={50} color="var(--mantine-color-lionstep-blue-5)" />
    </div>
  </Portal>
);

export default Spinner;
